import type { IOperatingLocationOverride } from '../types/global/operatingLocation.types';

const ISO2 = /^[A-Za-z]{2}$/;

export function isValidOperatingCountryCode(code?: string | null): code is string {
    return Boolean(code && ISO2.test(code));
}

export function normalizeOperatingCountryCode(code: string): string {
    return code.trim().toUpperCase();
}

/** Build X-Operating-* request headers from a stored override (admin tooling). */
export function buildOperatingLocationHeaders(override: IOperatingLocationOverride): Record<string, string> {
    const countryCode = normalizeOperatingCountryCode(override.country_code);
    if (!isValidOperatingCountryCode(countryCode)) return {};

    const headers: Record<string, string> = {
        'X-Operating-Country': countryCode,
    };

    if (override.country) headers['X-Operating-Country-Name'] = override.country;
    if (override.city) headers['X-Operating-City'] = override.city;
    if (override.state) headers['X-Operating-State'] = override.state;
    if (override.timezone) headers['X-Operating-Timezone'] = override.timezone;
    if (override.zip) headers['X-Operating-Zip'] = override.zip;
    if (override.metro_code) headers['X-Operating-Metro-Code'] = override.metro_code;
    if (override.latitude != null) headers['X-Operating-Latitude'] = String(override.latitude);
    if (override.longitude != null) headers['X-Operating-Longitude'] = String(override.longitude);

    const jsonPayload: Record<string, string | number> = { country_code: countryCode };
    if (override.country) jsonPayload.country = override.country;
    if (override.city) jsonPayload.city = override.city;
    if (override.state) jsonPayload.state = override.state;
    if (override.timezone) jsonPayload.timezone = override.timezone;
    if (override.latitude != null) jsonPayload.latitude = override.latitude;
    if (override.longitude != null) jsonPayload.longitude = override.longitude;

    headers['X-Operating-Location'] = JSON.stringify(jsonPayload);

    return headers;
}
